import { Descriptions, Divider, Flex, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Title from 'antd/es/typography/Title';
import { Fragment } from 'react';
import PriorityLevelTag from 'src/components/v2/Tag/PriorityLevelTag';
import { FlatItem } from 'src/types/elements.type';
import { IManpowerSupplyForm, IManpowerSupplyFormDetail } from 'src/types/helpdesk/manpowerSupplyForm.type';
import { formatDate, formatDateTime, formatTimeString } from 'src/utils/utils';

const { Text } = Typography;

type Props = {
  manpowerSupply?: IManpowerSupplyForm;
};

const columns = function (): ColumnsType<IManpowerSupplyFormDetail> {
  return [
    {
      title: 'Công việc',
      dataIndex: 'job',
      key: 'job',
      width: '30%',
      render: (value: string, record: IManpowerSupplyFormDetail) => (
        <Flex vertical gap={10}>
          <Text>
            Công việc cần thực hiện: <Text strong>{record.jobTitle}</Text>
          </Text>
          <Text>
            Chi tiết công việc: <Text strong>{record.jobDetail}</Text>
          </Text>
          <Text>
            Yêu cầu đặt thù của Công nhân viên: <Text strong>{record.jobRequirement}</Text>
          </Text>
        </Flex>
      )
    },
    {
      title: 'Ngày/giờ thực hiện',
      dataIndex: '',
      key: 'date',
      width: '20%',
      align: 'center',
      render: (record: IManpowerSupplyFormDetail) => (
        <Flex vertical gap={5}>
          <Text strong>
            {formatDate(record.fromDate)} - {formatDate(record.toDate)}
          </Text>
          <Text>
            {formatTimeString(record.startTime, true)} - {formatTimeString(record.endTime)}
          </Text>
        </Flex>
      )
    },
    {
      title: 'SL nhân lực',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      width: '10%'
    },
    {
      title: 'Nơi làm việc',
      dataIndex: '',
      width: '10%',
      key: 'workingAt',
      align: 'center',
      render: (record: IManpowerSupplyFormDetail) => <Text>{record.workingAt?.name}</Text>
    }
  ];
};

function ManpowerSupplyTab({ manpowerSupply }: Props) {
  return (
    <Fragment>
      <Flex justify='start'>
        <Title level={5}>Thông tin phiếu</Title>
      </Flex>
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
      >
        <Descriptions.Item label='ID'>{manpowerSupply?.id}</Descriptions.Item>
        <Descriptions.Item label='Độ ưu tiên'>
          <PriorityLevelTag priorityLevel={manpowerSupply?.priorityLevel as FlatItem} />
        </Descriptions.Item>
        <Descriptions.Item label='Người tạo'>{manpowerSupply?.createdByObj?.fullName}</Descriptions.Item>
        {/* <Descriptions.Item label='Bộ phận'>{manpowerSupply?.createdBy?.department.name}</Descriptions.Item> */}
        <Descriptions.Item label='Mã dự án'>{manpowerSupply?.projectCode}</Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>{formatDateTime(manpowerSupply?.createdDate)}</Descriptions.Item>
        <Descriptions.Item label='Loại nghiệp vụ'>{manpowerSupply?.manpowerSupplyType?.name}</Descriptions.Item>
      </Descriptions>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
      <Flex justify='start'>
        <Title level={5}>Thông tin liên hệ</Title>
      </Flex>
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
      >
        <Descriptions.Item label='Người liên hệ'>{manpowerSupply?.contactPerson}</Descriptions.Item>
        <Descriptions.Item label='Tên công ty'>{manpowerSupply?.companyName}</Descriptions.Item>
        <Descriptions.Item label='Chức vụ'>{manpowerSupply?.position}</Descriptions.Item>
        <Descriptions.Item label='Địa chỉ'>{manpowerSupply?.workplaceAddress}</Descriptions.Item>
        <Descriptions.Item label='Mã dự án'>{manpowerSupply?.projectCode}</Descriptions.Item>
        <Descriptions.Item label='Số điện thoại'>{manpowerSupply?.phone}</Descriptions.Item>
        <Descriptions.Item label='Ghi chú'>{manpowerSupply?.note}</Descriptions.Item>
      </Descriptions>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
      <Flex justify='start'>
        <Title level={5}>Danh sách yêu cầu cung ứng</Title>
      </Flex>
      <Table
        className='manpower-supply-form-table'
        columns={columns()}
        rowKey={(record) => String(record.id)}
        dataSource={manpowerSupply?.details}
        pagination={false}
        scroll={{ x: 400 }}
        bordered={false}
        size='small'
      />
    </Fragment>
  );
}

export default ManpowerSupplyTab;
